import { React, useState, useEffect, useMemo } from 'react'
import Avatar from "@mui/material/Avatar";
import TextField from '@mui/material/TextField';
import { timezonesList } from "../../asstes/timezones";
import { skillsLists } from "../../asstes/skills";
import { industriesList } from "../../asstes/industries";
import { countriesList } from "../../asstes/countries";
import MenuItem from '@mui/material/MenuItem';
import { Oval } from "react-loader-spinner";
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import SearchIcon from "@mui/icons-material/Search";
import { ListSubheader, InputAdornment, Input } from "@mui/material";
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import { nanoid } from "nanoid";
import { useNavigate } from "react-router-dom";
import Avatars from '../addCandidates/avatarsList';
import { Buffer } from "buffer";
import { makeStyles } from "@material-ui/core/styles";
import Box from '@mui/material/Box';
import Button from "../button/button";
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Rating from '@mui/material/Rating';
import { styled } from '@mui/material/styles';
import MessageDialog from "../dialogue/messageDialogue";
import CustomButton from "../button/button";
import {
  getAllBoards,
} from "../../redux/actions/boardActions";
import { useSelector, useDispatch } from "react-redux";
// Import supabase configuration
import supabase from "../../config/supabase";


const labels = {
  1: 'Novice',
  2: 'Beginner',
  3: 'Intermediate',
  4: 'Intermediate',
  5: 'Expert',
};

const color = {
  1: 'text-[#DE3151]',
  2: 'text-[#DE3151]',
  3: 'text-[#FFC805]',
  4: 'text-[#FFC805]',
  5: 'text-[#0DC650]',
};

function getLabelText(value) {
  return `${value} Star${value !== 0 ? 's' : ''}, ${labels[value]}`;
}


const useStyles = makeStyles((theme) => ({
  quantityRoot: {
    
    border: 'none',
    "&:hover": {
      
      border: 'none'
    },
    "&:focus-within": {
      
      border: 'none'
    },
    "& .MuiOutlinedInput-notchedOutline": {
      
      border: 'none'
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      
      border: 'none'
    },
    "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
      
      border: 'none'
    },
    "& .Mui-disabled": {
      border: 'none'
    },
    "& .Mui-disabled .MuiOutlinedInput-notchedOutline": {
      border: "none"
    }
  },
  icon: {
    color: "#0B5FFF",
  }
}));


const containsText = (value, searchText, check) => {
  if (check === 'timezone') {
    if (value.text?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1) {
      return true;
    } else if (value.value?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1) {
      return true;
    } else {
      return false;
    }
  } else if (check === 'states') {
    if (value?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1) {
      return true;
    } else {
      return false;
    }
  } else if (check === 'countries') {
    if (value.country?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1) {
      return true;
    } else {
      return false;
    }
  } else if (check === 'industry') {
    if (value.value?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1) {
      return true;
    } else {
      return false;
    }
  } else if (check === 'skills') {
    if (value.value?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1) {
      return true;
    } else {
      return false;
    }
  }
}
const style = {
  position: 'absolute',
  top: '30%',
  right: '10%',
  bgcolor: 'background.paper',
  height:436,
  width:431,
  boxShadow: 3,
  p: 4,
  borderRadius: 1
};

function RightDrawer({ isCompletedTab,deleteCandidate,showDeleteCandidateModal,setBoardInProfiles,boardInProfiles,setshowDeleteCandidateModal, candidateDetails,allMemojis, setIsDrawerOpen, setSuccessfullMessage, setShowMessage, candidatesDraft, setCandidatesDraft, wrongProspects, setWrongProspects, allGaperIds }) {

  const classes = useStyles();
  const filter = createFilterOptions();
  const navigate = useNavigate();

  const [skillLevelValue, setSkillLevelValue] = useState(1);
  const [SkillLevelhover, setSkillLevelHover] = useState(-1);
  const [showLoader, setShowLoader] = useState(false);
  const [showAvatars, setShowAvatars] = useState(false);
  const [miniScreen, setMiniScreen] = useState(false);
  const [error, setError] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchTextForStates, setSearchTextForStates] = useState("");
  const [searchTextForCountries, setSearchTextForCountries] = useState("");
  const [searchTextForIndustry, setSearchTextForIndustry] = useState("");
  const [searchTextForSkills, setSearchTextForSkills] = useState("");
  const [skillList, setSkillList] = useState([]);
  const [skillWithExpList, setSkillWithExpList] = useState([]);
  const [selectedIndustries,setSelectedIndustries] = useState([]);
  const [availability, setAvailability] = useState([
    { id: "1", val: "Immediate" },
    { id: "2", val: "Within 1 week" },
    { id: "3", val: "Within 2 weeks" },
    { id: "4", val: "Within 1 month" },
    { id: "5", val: "Within 2 months" },
    { id: "6", val: "After 2 month" },
  ]);
  const [CV, setCV] = useState("");
  const [cvLink, setCvLink] = useState("");
  const [draftCv,setDraftCv] = useState(false);
  const [draftCvValue,setDraftCvValue] = useState("")
  const [avatarSelected, setAvatarSelected] = useState('');
  const [avatarsList, setAvatarsList] = useState([]);
  const [displaySkillsOptions, setDisplaySkillsOptions] = useState([]);
  const [displayIndustryOptions, setDisplayIndustryOptions] = useState([]);
  const [values, setValues] = useState([{ id: 0, fullName: '', error: false }, { id: 1, gaperId: '', error: false }, { id: 2, email: '', error: false }, { id: 3, contractStatus: '', error: false }, { id: 4, experienceInYears: '', error: false }, { id: 5, hourlyRate: '', error: false }, { id: 6, industry: '', error: false }, { id: 7, SelectedCountry: '', error: false }, { id: 8, SelectedState: '', error: false }, { id: 9, timeZone: '', error: false }, { id: 10, overlappingHours: '', error: false }, { id: 11, availabilityValue: '', error: false }, { id: 12, languageProficiency: '', error: false }, { id: 13, skill: '', error: false }, { id: 14, skillExp: '', error: false }, { id: 15, currentJobTitle: '', error: false }, { id: 16, cvFile: '', error: false }])
  const [openModal, setOpenModal] = useState(false);
  const [oldMemojiData,setOldMemojiData] = useState(null)
  const availableState = countriesList.find((c) => c.country === values[7].SelectedCountry);
  // const [showDeleteCandidateModal, setshowDeleteCandidateModal] = useState(false);
  const [profileBoards,setProfileBoards] = useState(false);
  const dispatch = useDispatch();
  const data = useSelector((state) => state.boards);

  const StyledRating = styled(Rating)({
    '& .MuiRating-iconFilled': {
        borderRadius: '2px', 
        marginLeft: '2px',
        backgroundColor: `${skillLevelValue <= 2 ? '#DE3151' : skillLevelValue <= 4 ? '#FFC805' : '#0DC650'}`,
    },
    '& .MuiRating-iconHover': {
        marginLeft: '2px',
        backgroundColor: `${SkillLevelhover <= 2 ? '#DE3151' : SkillLevelhover <= 4 ? '#FFC805' : '#0DC650'}`,
    },
  });
  
  const reportWindowSize = (e) => {
    var screenSize = window.screen.availWidth;
    if (screenSize < 780) {
      setMiniScreen(true);
    } else {
      setMiniScreen(false);
    }
  }

  useEffect(async () => {
    window.addEventListener('resize', (e) => reportWindowSize(e));
    setOldMemojiData(candidateDetails)
    const { data, error } = await supabase
      .from('avatars')
      .select('*')

    if (data && data.length) {
      var avatars = [...data];
      avatars = data.map((d) => {
        var newAvatarObject = { ...d }
        newAvatarObject.color = getRandomColor();
        return newAvatarObject
      })
      setAvatarsList(avatars);
    }
    await dispatch(getAllBoards());
  }, [])
  useEffect(() => {
    var boardName = []
    if(data && data.length){
      data.forEach((board) => {
        board?.board_profiles[0]?.profiles?.forEach((elem) => {
          if(elem.id === candidateDetails.id){
            console.log('board name ' + board.name);
            console.log('board name ' + board.id);
            
            boardName.push({id:board.id,boardName:board.name})
          }
        })
      })
      setBoardInProfiles(boardName)
    }
  },[data]);
  useEffect(() => {
    var newState = [...values];
    newState[0].fullName = candidateDetails['Name'];
    // newState[1].gaperId = candidateDetails['Gaper Id'];
    var chars = candidateDetails['Gaper Id']?.slice(0, candidateDetails['Gaper Id'].search(/\d/));
    var newGaperId = candidateDetails['Gaper Id']?.replace(chars, '');
    newState[1].gaperId = newGaperId;
    var checkIfExist = allGaperIds.findIndex((elem) => candidateDetails['Gaper Id'] == elem);
    if(!((/[0-9]{4}/).test(candidateDetails['Gaper Id'])) || checkIfExist !== -1){
      newState[1].error = true;
    }
    newState[2].email = candidateDetails['Email']
    if(candidateDetails['Email'] && !(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(candidateDetails['Email'])){
      newState[2].error = true;
    }
    let newContractStatus = candidateDetails['Contract status']?.toLowerCase();
    newState[3].contractStatus = capitalizeFirstLetter(newContractStatus)
    newState[4].experienceInYears = candidateDetails['Exp']?.split(' ')[0];
    newState[5].hourlyRate = candidateDetails['Internal Rate']?.split(' ')[0];
    let newLocation = candidateDetails["Location"]?.toLowerCase();
    newState[7].SelectedCountry = capitalizeFirstLetter(newLocation)
    let newSelectedState = candidateDetails["State"]?.toLowerCase();
    newState[8].SelectedState = capitalizeFirstLetter(newSelectedState)
    newState[9].timeZone = candidateDetails['Time zone']
    if(!((/[u]+[t]+[c]+[a-z0-9)+-]{2,}/i).test(candidateDetails['Time zone']))){
      newState[9].error = true;
    }
    newState[10].overlappingHours = checkOverlappingHours(candidateDetails['Overlapping hours'])
    newState[11].availabilityValue = checkAvailability(candidateDetails['Availability'])
    newState[12].languageProficiency = checkLanguageProficiency(candidateDetails['Language proficiency'])
    newState[15].currentJobTitle = candidateDetails['Title']
    console.log(candidateDetails)
    setValues(newState);
    var skills = candidateDetails['Skills'] || [];
    setSkillList(skills);
    var skillWithExpDb = candidateDetails['Skills']?.map((el) => {
      var updatedValue = {...el}
      updatedValue.year = el.level
      updatedValue.level = el.level
      return updatedValue
    });
    skillWithExpDb = skillWithExpDb || [];
    setSkillWithExpList(skillWithExpDb);
    var industries = (candidateDetails['Industry']?.length > 1 ? candidateDetails['Industry']?.split(',') : candidateDetails['Industry']) || [];
    setSelectedIndustries(industries);
    if(candidateDetails['CvLink']){
      setDraftCv(true);
      setDraftCvValue(candidateDetails['CvLink']);
    }
    isCompletedTab && setCvLink(candidateDetails['CvLink'])
  }, [])

  const capitalizeFirstLetter = (location) => {
    if (location === "usa") {
      return location?.toUpperCase();
    }
    else {
      return location?.replace(/\b\w/g, c => c.toUpperCase());
    }
  }
  const checkEmail = (email) =>{
    if((/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(email)){
      setError(false)
      return email;
    }
    values[2].error = true;
    setError(true)
    return email;
  }
  const checkTimeZone = (timezone) =>{
    if(((/[u]+[t]+[c]+[a-z0-9)+-]{2,}/i).test(candidateDetails['Time zone']))){
      setError(false)
      return timezone;
    }
    values[9].error = true;
    setError(true);
    return timezone;
  }
  const checkLanguageProficiency = (language) =>{
    if(language === ""){
      return "";
    }
    else if(language >= 3 ){
      return 3;
    }
    else if(language <= 0){
      return 1;
    }
    return language;
  }
const checkOverlappingHours = (hours) =>{
  if(hours ===""){
    return ""
  }
  else if(hours >= 7){
    return 7;
  }
  else if(hours <= 0){
    return 0;
  }
  return hours;
}
  function getRandomColor() {
    var letters = 'BCDEF'.split('');
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * letters.length)];
    }
    return color;
  }

  const displayTimezoneOptions = useMemo(() => {
    if (timezonesList.length > 0) {
      // this will return array of object which can't be render in select options
      var timezoneOptionsObject = timezonesList.filter((timezone) => containsText(timezone, searchText, 'timezone'));

      // so we are going to just make array of values to pass to select options to render
      var timezoneOptionsArray = timezoneOptionsObject.map((timezone) => {
        return timezone.text;
      })
      return timezoneOptionsArray;
    }
  }, [searchText]);

  const displayStatesOptions = useMemo(() => {
    if (availableState?.states.length > 0) {
      var stateOptions = availableState.states.filter((object) => containsText(object, searchTextForStates, 'states'));

      return stateOptions;
    }
  }, [searchTextForStates, availableState]);

  const displayCountriesOptions = useMemo(() => {
    if (countriesList?.length > 0) {
      var countryOptionsObject = countriesList.filter((object) => containsText(object, searchTextForCountries, 'countries'));
      return countryOptionsObject;
    }
  }, [searchTextForCountries]);

  useMemo ( () => {
    if(industriesList?.length > 0){
        var indusrtyOptionsObject = industriesList.filter((object) => containsText(object, searchTextForIndustry, 'industry'));
        setDisplayIndustryOptions(indusrtyOptionsObject);
    }
}, [searchTextForIndustry]);

  useMemo ( () => {
    if(displaySkillsOptions?.length > 0){
        var skillsOptionsObject = displaySkillsOptions.filter((object) => containsText(object, searchTextForSkills, 'skills'));
        setDisplaySkillsOptions(skillsOptionsObject);
    }
    else if(skillsLists?.length > 0){
        var skillsOptionsObject = skillsLists.filter((object) => containsText(object, searchTextForSkills, 'skills'));
        setDisplaySkillsOptions(skillsOptionsObject);
    }
}, [searchTextForSkills]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    var flag = false;
    if(!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(values[2].email) && values[2].email?.length > 0){
      setValues((prev) => {
        var newstate = [...prev];
        newstate[2].error = true;
        return newstate;
      });
      setError(true)
      flag = true;
    }
    if(!(/[u]+[t]+[c]+[a-z0-9)+-]{2,}/i).test(values[9].timeZone)){
      setValues((prev) => {
        var newstate = [...prev];
        newstate[9].error = true;
        return newstate;
      });
      setError(true)
      flag = true;
    }
    values.forEach((obj, index) => {
      if (obj[Object.keys(obj)[1]] === '' && Object.keys(obj)[1] !== 'email') {
        if (Object.keys(obj)[1] === 'skill' || Object.keys(obj)[1] === 'skillExp') {
          if (skillList.length <= 0) {
            setValues((prev) => {
              var newstate = [...prev];
              newstate[index].error = true;
              return newstate;
            });
            setError(true);
            flag = true;
          }
        } else if(Object.keys(obj)[1] === 'industry'){
          if(selectedIndustries.length <= 0){
              setValues((prev) => {
                  var newstate = [...prev];
                  newstate[index].error = true;
                  return newstate;
              });
              setError(true);
              flag = true;
          }
        } else if(Object.keys(obj)[1] === 'cvFile') {
          if( isCompletedTab && cvLink.length <= 0 && values[16].cvFile?.length <= 0){
            setValues((prev) => {
              var newstate = [...prev];
              newstate[index].error = true;
              return newstate;
            });
            setError(true);
            flag = true;
          } else if(!isCompletedTab && values[16].cvFile?.length <= 0){
            setValues((prev) => {
              var newstate = [...prev];
              newstate[index].error = true;
              return newstate;
            });
            setError(true);
            flag = true;
          }
        } else {
          setValues((prev) => {
            var newstate = [...prev];
            newstate[index].error = true;
            return newstate;
          });
          setError(true);
          flag = true;
        }
      } else if (Object.keys(obj)[1] === 'experienceInYears') {
        if (obj.experienceInYears > 20) {
          setValues((prev) => {
            var newstate = [...prev];
            newstate[index].error = true;
            return newstate;
          });
          setError(true);
          flag = true;
        }
      }
    })
    if (!flag) {
      
    
      setShowLoader(true);
      var availability = checkAvailabilityInDays();
      var skillLevel = CheckSkillExperience();
      var skillsWithLevels = [];

      if (skillList?.length > 0) {
        skillsWithLevels = skillList;
      } else {
        skillsWithLevels.push({
          "skill": values[13].skill,
          "level": skillLevelValue
        })
      }
      var industries = [...selectedIndustries]
      if(selectedIndustries?.length <= 0) {
          industries.push(values[6].industry)
      }
      var allProfiles = '';
      if(isCompletedTab){
        if(values[16].cvFile?.name?.length > 0){
          let id = nanoid().substring(0, 11);
        let extension = "pdf";
        let randomName = id + "." + extension;
  
        var res = await supabase.storage.from('data').upload(`cvs/${randomName}`, values[16].cvFile);
  
        // Get file link
        var cv = res.data ? res.data.Key.substring(res.data.Key.indexOf("/") + 1) : "";
  
        const { signedURL, error } = await supabase
          .storage
          .from('data')
          .createSignedUrl(cv, 315569260)

          if(signedURL){
            allProfiles = await supabase
                .from('all_profiles')
                .update({ full_name: values[0].fullName, serial_no: values[1].gaperId, email: values[2].email, current_job_title: values[15].currentJobTitle, exp: values[4].experienceInYears, contract_status: values[3].contractStatus, location: values[7].SelectedCountry, states: values[8].SelectedState, timezone: values[9].timeZone, expected_hourly_rate: values[5].hourlyRate, availability: availability, overlapping_hours: values[10].overlappingHours, language_proficiency: values[12].languageProficiency, skill_level: skillsWithLevels, industries: industries.toString(), cv_link: signedURL, emoji_url: candidateDetails.memoji.avatar_url,cv_name:randomName })
                .match({ id: candidateDetails['id']});
          }
        } else {
          allProfiles = await supabase
              .from('all_profiles')
              .update({ full_name: values[0].fullName, serial_no: values[1].gaperId, email: values[2].email, current_job_title: values[15].currentJobTitle, exp: values[4].experienceInYears, contract_status: values[3].contractStatus, location: values[7].SelectedCountry, states: values[8].SelectedState, timezone: values[9].timeZone, expected_hourly_rate: values[5].hourlyRate, availability: availability, overlapping_hours: values[10].overlappingHours, language_proficiency: values[12].languageProficiency, skill_level: skillsWithLevels, industries: industries.toString(), cv_link: cvLink, emoji_url: candidateDetails.memoji.avatar_url })
              .match({ id: candidateDetails['id']});
        }
      } else {
        let id = nanoid().substring(0, 11);
        let extension = "pdf";
        let randomName = id + "." + extension;
  
        var res = await supabase.storage.from('data').upload(`cvs/${randomName}`, values[16].cvFile);
  
        // Get file link
        var cv = res.data ? res.data.Key.substring(res.data.Key.indexOf("/") + 1) : "";
  
        const { signedURL, error } = await supabase
          .storage
          .from('data')
          .createSignedUrl(cv, 315569260)
  
        if (signedURL) {
          allProfiles = await supabase
            .from('all_profiles')
            .insert({ full_name: values[0].fullName, serial_no: values[1].gaperId, email: values[2].email, current_job_title: values[15].currentJobTitle, exp: values[4].experienceInYears, contract_status: values[3].contractStatus, location: values[7].SelectedCountry, states: values[8].SelectedState, timezone: values[9].timeZone, expected_hourly_rate: values[5].hourlyRate, availability: availability, overlapping_hours: values[10].overlappingHours, language_proficiency: values[12].languageProficiency, skill_level: skillsWithLevels, industries: industries.toString(), cv_link: signedURL, emoji_url: candidateDetails.memoji.avatar_url,cv_name:randomName });
        }
      }
      if (allProfiles?.data && allProfiles?.data.length > 0) {
        setShowLoader(false)
        setIsDrawerOpen(false)
        setShowMessage(true)
        // let updateCandidateDetails = [...candidateDetails];
        candidateDetails['Availability'] = reverseAvailabilityInDays(availability);
        candidateDetails['Contract status'] = values[3].contractStatus;
        candidateDetails['Email'] = values[2].email;
        candidateDetails['Exp'] = values[4].experienceInYears +" years";
        candidateDetails['Gaper Id'] = values[1].gaperId;
        candidateDetails['Industry'] = industries.toString();
        candidateDetails['Internal Rate'] = values[5].hourlyRate + " USD/Hour";
        candidateDetails['Language proficiency'] = values[12].languageProficiency;
        candidateDetails['Location'] = values[7].SelectedCountry;
        candidateDetails['Name'] = values[0].fullName;
        candidateDetails['Overlapping hours'] = values[10].overlappingHours;
        candidateDetails['State'] = values[8].SelectedState;
        candidateDetails['Time zone'] = values[9].timeZone;
        candidateDetails['Title'] = values[15].currentJobTitle;
        console.log("candidates after submission",candidateDetails);
        // removed from drafts
        let candidates = candidatesDraft.filter((data) => data['Gaper Id'] !== candidateDetails['Gaper Id'])
        setCandidatesDraft(candidates)
        localStorage.setItem("candidates", JSON.stringify(candidates));
        // removed from wrong prospect
        let wrongProfiles = wrongProspects.filter((el) => el.id !== candidateDetails.id)
        setWrongProspects(wrongProfiles);

        setSuccessfullMessage("Profile Added Successfully");

        const memojiUpdateResponse = await supabase
        .from('avatars')
        .update({ isAssigned: 'true' })
        .match({ id: candidateDetails.memoji.id })
      }
    }
  }
const reverseAvailabilityInDays = (ava) =>{
  if (ava === 0) {
    return "Immediate";
  } else if (ava === 7) {
    return "Within 1 week";
  } else if (ava === 14) {
    return "Within 2 weeks";
  } else if (ava === 30) {
    return "Within 1 month";
  } else if (ava === 60) {
    return "Within 2 months";
  } else if (ava === 65) {
    return "After 2 month";
  }
}
  const checkAvailabilityInDays = () => {
    if (values[11].availabilityValue === "Immediate") {
      return 0;
    } else if (values[11].availabilityValue === "Within 1 week") {
      return 7;
    } else if (values[11].availabilityValue === "Within 2 weeks") {
      return 14;
    } else if (values[11].availabilityValue === "Within 1 month") {
      return 30;
    } else if (values[11].availabilityValue === "Within 2 months") {
      return 60;
    } else if (values[11].availabilityValue === "After 2 month") {
      return 65;
    }
  }

  const checkAvailability = (candidateValue) => {
    if(candidateValue === ""){
      return "";
    }
    else if (candidateValue === 0) {
      return "Immediate";
    } else if (candidateValue <= 7) {
      return "Within 1 week";
    } else if (candidateValue <= 14) {
      return "Within 2 weeks";
    } else if (candidateValue <= 30) {
      return "Within 1 month";
    } else if (candidateValue <= 60) {
      return "Within 2 months";
    } else if (candidateValue > 60) {
      return "After 2 month";
    }
  }

  const CheckSkillExperience = () => {
    if (values[14].skillExp <= 5) {
      return values[14].skillExp;
    } else {
      return 5;
    }
  }

  const handleSkillAdd = () =>{ 
    if(values[13].skill !== '' && values[14].skillExp !== ''){
        var skillLevel = CheckSkillExperience();
        var isAlreadyExist = false
        skillWithExpList?.forEach((el, i) => {
            if(el.skill === values[13].skill){
                isAlreadyExist = true
            }
        })
        if(isAlreadyExist){
            var updateSkillList = [...skillList];
            var updateSkillWithExpList = [...skillWithExpList];
            updateSkillList = updateSkillList.map((el) => {
                if(el.skill === values[13].skill){
                    var updatedValue = {...el};
                    updatedValue.skill = values[13].skill;
                    updatedValue.level = skillLevelValue ;
                    return updatedValue;
                } else {
                    return el
                }
            })
            updateSkillWithExpList = updateSkillWithExpList.map((el) => {
                if(el.skill === values[13].skill){
                    var updatedValue = {...el};
                    updatedValue.skill = values[13].skill
                    updatedValue.year = values[14].skillExp;
                    updatedValue.level = skillLevelValue;
                    return updatedValue;
                } else {
                    return el
                }
            })
            setSkillList(updateSkillList);
            setSkillWithExpList(updateSkillWithExpList);
        } else{
            var skillOptions = displaySkillsOptions.filter((object) => {
                if(object.value !== values[13].skill){
                    return object;
                }
            });
            setDisplaySkillsOptions(skillOptions);
            setSkillList([...skillList,{"skill": values[13].skill,"level": skillLevelValue}])
            setSkillWithExpList([...skillWithExpList,{"skill": values[13].skill,"year": values[14].skillExp,"level": skillLevelValue}]);
        }
        setSkillLevelValue(1);
        var newState = [...values];
        newState[13].skill = '';
        newState[14].skillExp = '';
        setValues(newState);
    } else {
        if(values[13].skill === '' && values[14].skillExp === '') {
            setValues((prev) => {
                var newstate = [...prev];
                newstate[13].error = true;
                newstate[14].error = true;
                return newstate;
            });
        } else {
            if(values[13].skill === '') {
                setValues((prev) => {
                    var newstate = [...prev];
                    newstate[13].error = true;
                    return newstate;
                });
            } else {
                setValues((prev) => {
                    var newstate = [...prev];
                    newstate[14].error = true;
                    return newstate;
                });
            }
        }
    }
  }

  const handleIndustryAdd = () =>{ 
      if(values[6].industry !== ''){
          var isAlreadyExist = false
          selectedIndustries.forEach((el, i) => {
              if(el === values[6].industry){
                  isAlreadyExist = true
              }
          })
          if(isAlreadyExist){
              setValues((prev) => {
                  var newstate = [...prev];
                  newstate[6].error = true;
                  return newstate;
              });
          } else {
              var industryOptions = displayIndustryOptions.filter((object) => {
                  if(object.value !== values[6].industry){
                      return object;
                  }
              });
              setDisplayIndustryOptions(industryOptions);
              setSelectedIndustries([...selectedIndustries,values[6].industry])
          }
          var newState = [...values];
          newState[6].industry = '';
          setValues(newState);
          setError(false)
      } else {
          setValues((prev) => {
              var newstate = [...prev];
              newstate[6].error = true;
              return newstate;
          });
      }
  }

  const handleFileUpload = async (e) => {
    console.log(e.target.files[0]);
    const maxfileSize = 1024 * 1024;
    const fileSize = e.target.files[0]?.size;
    if (fileSize > maxfileSize) {
      var newState = [...values];
      newState[16].error = true;
      setValues(newState);
    } else {
      var newState = [...values];
      newState[16].cvFile = e.target.files[0];
      newState[16].error = false;
      setValues(newState);
      setError(false)
    }
  }

  const handleChooseAvatar = (memojiObject) => {
    setAvatarSelected(memojiObject);
    console.log('select emoji is',memojiObject)
  }

// memoji upload click
  const handleUploadClick = (candidateDetails)=> {
    candidateDetails.memoji.avatar_url = avatarSelected.avatar_url;
    candidateDetails.memoji.id  = avatarSelected.id;
    setOpenModal(false);
  }

  const handleDrawerClose = (candidateDetails) =>{
    candidateDetails.memoji.avatar_url = oldMemojiData.memoji.avatar_url;
    candidateDetails.memoji.id  = oldMemojiData.memoji.id;
    setIsDrawerOpen(false);
    setProfileBoards(false);
  }

  // removing a skill from a skillList
  const removeSkill = (skill) => {
    var afterRemove = skillList.filter((value) => value.skill !== skill);
    var afterRemovefromskillWithExp = skillWithExpList.filter((value) => value.skill !== skill);
    setSkillList(afterRemove);
    setSkillWithExpList(afterRemovefromskillWithExp);
    var isAlreadyExist = false
    displaySkillsOptions.forEach((el, i) => {
        if(el.value === skill){
            isAlreadyExist = true
        }
    })
    if(!isAlreadyExist){
        var skillOptions = [...displaySkillsOptions, {value: skill}]
        setDisplaySkillsOptions(skillOptions)
    }
}

const editSkill = (skillObject) => {
    var isAlreadyExist = false
    displaySkillsOptions.forEach((el, i) => {
        if(el.value === skillObject.skill){
            isAlreadyExist = true
        }
    })
    if(!isAlreadyExist){
        var skillOptions = [...displaySkillsOptions, {value: skillObject.skill}]
        setDisplaySkillsOptions(skillOptions)
    }
    setSkillLevelHover(-1);
    setSkillLevelValue(skillObject.level);
    var newstate = [...values];
    newstate[14].skillExp = skillObject.year;
    newstate[13].skill = skillObject.skill;
    newstate[14].error = false;
    newstate[13].error = false;
    setValues(newstate);
}

// removing a industry from a industryList
const removeIndustry = (industry) => {
  var afterRemove = selectedIndustries.filter((value) => value !== industry);
  setSelectedIndustries(afterRemove);
  var isAlreadyExist = false
  displayIndustryOptions.forEach((el, i) => {
        if(el.value === industry){
            isAlreadyExist = true
        }
    })
    if(!isAlreadyExist){
        var industryOptions = [...displayIndustryOptions, {value: industry}]
        setDisplayIndustryOptions(industryOptions);
    }
}

const editIndustry = (industry) => {
    var isAlreadyExist = false
    displayIndustryOptions.forEach((el, i) => {
        if(el.value === industry){
            isAlreadyExist = true
        }
    })
    if(!isAlreadyExist){
        var industryOptions = [...displayIndustryOptions, {value: industry}]
        setDisplayIndustryOptions(industryOptions);
    }
    var newstate = [...values];
    newstate[6].industry = industry;
    newstate[6].error = false;
    setValues(newstate);
}

  const handleChange = (index, key) => (event) => {
    var newstate = [...values];
    if (key === 'hourlyRate') {
      newstate[index][key] = parseInt(event.target.value);
      newstate[index].error = false;
      setValues(newstate);
      setError(false)
    } else if (key === 'SelectedCountry') {
      newstate[index][key] = event.target.value;
      newstate[index].error = false;
      newstate[index + 1].SelectedState = '';
      setValues(newstate);
      setError(false)
    } else {
      newstate[index][key] = event.target.value;
      newstate[index].error = false;
      setValues(newstate);
      setError(false)
    }
  };

  const handleOnBlurEvent = (index,key) => {
    var newstate = [...values];
    if(key === 'experienceInYears'){
        if(newstate[index][key] > 20){
            newstate[index][key] = 20;
            newstate[index].error = false;
            setValues(newstate);
        } else if(newstate[index][key] < 0){
          newstate[index][key] = 0;
          newstate[index].error = false;
        }
    } else if(key === 'hourlyRate'){
        if(newstate[index][key] > 1000) {
            newstate[index][key] = 1000;
            newstate[index].error = false;
            setValues(newstate);
        } else if(newstate[index][key] < 0){
          newstate[index][key] = 0;
          newstate[index].error = false;
        }
    } else if(key === 'gaperId'){
      if(newstate[index][key] < 0){
          newstate[index][key] = 0;
          newstate[index].error = false;
      }
      var checkIfExist = allGaperIds.findIndex((elem) => newstate[index][key] == elem);
      if(checkIfExist !== -1) {
          newstate[index].error = true;
      }
      setValues(newstate);
    }
}

  const usePlaceholderStyles = makeStyles(theme => ({
    placeholder: {
      color: "#aaa"
    }
  }));
  const Placeholder = ({ children }) => {
    const classes = usePlaceholderStyles();
    return <div className={classes.placeholder}>{children}</div>;
  };
  // Memoji modal
  const handleOpen = () => {
    setOpenModal(true);
    console.log("memojis are",allMemojis);
  }
  const handleClose = () => setOpenModal(false);
  return (
    <>
    <div>
    <div className='float-right fixed bottom-8 right-2 hover:cursor-pointer' onClick={handleSubmit}>
        <img src='scrollSave.svg' alt='scroll save button' />
    </div>
      {showLoader && (
        <div className="fixed flex items-center justify-start z-10 w-full h-full top-0 bg-white-1">
          {/* Add backdrop */}

          <div className={`relative flex`}>
            <Oval
              color="white"
              secondaryColor="grey"
              height="40"
              width="60"
            />
            <div className="flex items-center">Hold Tight-just getting this page ready.</div>
          </div>
        </div>
      )}
        {/* Message dialogue on board's delete button click start here */}
        <MessageDialog
        title="Delete Candidate"
        onClick={() => {
          setshowDeleteCandidateModal(false);
        }}
        show={showDeleteCandidateModal}
      >
        <form className="" onSubmit={deleteCandidate(candidateDetails['id'],candidateDetails['cv_name'])}>
          {
            <div className="grid grid-cols-12 gap-3 col-span-12">
              {
                console.log(boardInProfiles[0]?.boardName)
              }
              {/* Show message */}
              {
                
                
                boardInProfiles?.length ?
              <div className="col-span-12 ">
                This candidate is added in the <span className='font-semibold'>{boardInProfiles[0]?.boardName} {boardInProfiles.length > 1 && `+${boardInProfiles?.length-1} other boards’`}</span>Are you sure you want to delete this profile?
              </div>:
              <div className="col-span-12 ">
              Are you sure you want to delete this profile?
              </div>
              }

              {/* Button */}
              <div className="col-span-12 mt-2 flex space-x-2 justify-start">
              <CustomButton
                  type="submit"
                  value="Delete"
                  buttonType="secondary-2"
                />
                <CustomButton
                  type="button"
                  onClick={() => {
                    setshowDeleteCandidateModal(false);
                  }}
                  value="Cancel"
                  buttonType="cancel"
                />
              </div>
            </div>
            
          }
        </form>
      </MessageDialog>
      {/* Delete board dialogue button ends here */}   

        {/* Memoji modal */}
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        hideBackdrop={true}
        className="rounded-md"
      >
        <Box sx={style}>
          <div className='grid grid-cols-12'>
            <div className="col-span-12 text-[24px] font-semibold">Choose an avatar</div>
          </div>
          <div className='grid grid-cols-12 scrollbar' style={{overflowY: "auto", maxHeight: "283px"}}>
              {
                allMemojis.map((memoji)=>{
                  return (
                    <div className='col-span-3 p-1 flex items-center hover:cursor-pointer' onClick={()=>handleChooseAvatar(memoji)} >
                        <div className={`p-3 rounded-full ${memoji?.avatar_url === avatarSelected?.avatar_url ? 'border-blue-4 border-2' : ''}`} style={{backgroundColor: memoji?.color}}><Avatar src={`${memoji?.avatar_url}`} imgProps={ {'style':{'objectFit': 'contain'}}} /></div>
                    </div>
                  )
                })
              }
          </div>
          <div className="mt-5 grid grid-cols-12 gap-2">
            <div className="col-span-4 hover:cursor-pointer">
              <Button buttonType="next" value="Upload" className="md:w-[130px] md:h-[48px]" onClick={()=>handleUploadClick(candidateDetails)} />
            </div>
            <div className="flex items-center col-span-4 ml-6 hover:cursor-pointer" onClick={handleClose}>
              <div className='text-blue-1 text-[16px]'>Cancel</div>
            </div>
          </div>
        </Box>
      </Modal>

      <div className='float-right -mt-4 -mr-4 hover:cursor-pointer' onClick={() => handleDrawerClose(candidateDetails)}>
        <img src='Close.svg' alt='close Arrow' />
      </div>
      <div className=''>
        <form onSubmit={handleSubmit}>
          <div id="element" className={`${showAvatars && 'hidden'} w-auto h-auto bg-white-1 rounded-md md:pl-4 md:pr-12 md:pt-2 md:pb-2 `}>
            <div className="bg-blue-7 w-fit p-2 rounded md:hidden mb-2">
              <span className='md:font-semibold text-blue-1'>Step 1 of 2</span>
            </div>
            <div className='flex justify-between items-center'>
              {
              isCompletedTab ?
               <>
                <div className="p-3 rounded-full hover:cursor-pointer" style={{backgroundColor: candidateDetails?.memoji?.color}} onClick={handleOpen} ><Avatar src={`${candidateDetails?.memoji?.avatar_url}`} imgProps={ {'style':{'objectFit': 'contain'}}} /></div>
                <div className='hover:cursor-pointer' onClick={()=> setshowDeleteCandidateModal(true)}><img src="./deleteCandidate.svg" alt='Delete Candidate' /></div>
               </>
               :
               <>
              <h1 className="text-2xl font-bold">Edit Candidate</h1>
              <div className="p-3 rounded-full hover:cursor-pointer" style={{backgroundColor: candidateDetails?.memoji?.color}} onClick={handleOpen} ><Avatar src={`${candidateDetails?.memoji?.avatar_url}`} imgProps={ {'style':{'objectFit': 'contain'}}} /></div>
              </>
              }
            </div>
            <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${error ? "visible" : "invisible"}`}>Some of the fields are missing!</p>


            <div className="mt-6">
              <form>
                <div className='md:grid md:grid-cols-12 md:gap-2 gap-2 flex md:justify-center items-center justify-between'>
                  <div className="md:col-span-4 omd-1:basis-5/12">
                    <div className="flex justify-between">
                      <label htmlFor="contact" className="block mb-2 md:text-base text-sm font-medium text-black-1">Skills</label>
                      <p className={`text-sm omd-1:hidden text-red-1 font-medium italic ${values[13].error ? "visible" : "invisible"}`}>Select skill.</p>
                      <p className={`md:hidden text-xs text-red-1 font-normal italic ${values[13].error ? "visible" : "invisible"}`}>Add skill</p>
                    </div>
                    <Autocomplete
                      className={`${values[13].error ? "border-red-1":""}`}
                      value={values[13].skill}
                      onChange={(event, newValue) => {
                          if (typeof newValue === 'string') {
                              var newstate = [...values];
                              newstate[13].skill = newValue;
                              newstate[13].error = false;
                              setValues(newstate);
                          } else if (newValue && newValue.inputValue) {
                          // Create a new value from the user input
                              var newstate = [...values];
                              newstate[13].skill = newValue?.inputValue;
                              newstate[13].error = false;
                              setValues(newstate);
                          } else {
                              var newstate = [...values];
                              newstate[13].skill = newValue?.value || '';
                              newstate[13].error = false;
                              setValues(newstate);
                          }
                      }}
                      filterOptions={(options, params) => {
                          const filtered = filter(options, params);
                  
                          const { inputValue } = params;
                          // Suggest the creation of a new value
                          const isExisting = options.some((option) => inputValue === option.value);
                          if (inputValue !== '' && !isExisting) {
                          filtered.push({
                              inputValue,
                              value: `Add "${inputValue}"`,
                          });
                          }
                  
                          return filtered;
                      }}
                      selectOnFocus
                      clearOnBlur
                      handleHomeEndKeys
                      id="skill"
                      options={displaySkillsOptions}
                      getOptionLabel={(option) => {
                          // Value selected with enter, right from the input
                          if (typeof option === 'string') {
                          return option;
                          }
                          // Add "xxx" option created dynamically
                          if (option.inputValue) {
                          return option.inputValue;
                          }
                          // Regular option
                          return option.value;
                      }}
                      renderOption={(props, option) => <li {...props}>{option.value}</li>}
                      sx={{ width: 2/2 }}
                      freeSolo
                      includeInputInList
                      renderInput={(params) => (
                          <TextField {...params} error={values[13].error} placeholder={miniScreen ? 'Skills' : 'Select skills' } />
                      )}
                      />
                  </div>
                  <div className="md:col-span-3 omd-1:basis-5/12">
                    <div className="flex justify-between items-center mb-2.5">
                    <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic w-full text-right ${values[14].error ? "visible":"invisible"}`}>Select years.</p>
                    </div>
                    <Select
                    error={values[14].error}
                    value={values[14].skillExp}
                    onChange={handleChange(14,'skillExp')}
                    displayEmpty
                    renderValue={
                      values[14].skillExp !== "" ? undefined : () => <Placeholder>Exp</Placeholder>
                        }
                    sx={{ width: 2/2 }}
                    > 
                        <MenuItem>Select experience</MenuItem>
                        {
                        [...Array(21)].map((x, i) =>(
                            <MenuItem key={i} value={i+1}>{i+1}</MenuItem>
                        ))
                        }
                    </Select>
                  </div>
                  <div className="md:col-span-5 omd-1:basis-5/12">
                      <div className="flex justify-between items-center omd-1:mb-2.5">
                      <label className="block omd-1:hidden mb-2 md:text-base text-sm font-medium text-black-1">Level - <span className={`${skillLevelValue !== null && (
                                        color[SkillLevelhover !== -1 ? SkillLevelhover : skillLevelValue]
                                    )}`} id="skillLevel">{skillLevelValue !== null && (
                          labels[SkillLevelhover !== -1 ? SkillLevelhover : skillLevelValue]
                      )}</span></label>
                      </div>
                      <div className="flex justify-between h-10 w-full cursor-pointer rounded-lg">
                          <StyledRating
                              name="hover-feedback"
                              value={skillLevelValue}
                              size='medium'
                              getLabelText={getLabelText}
                              onChange={(event, newValue) => {
                                  setSkillLevelValue(newValue);
                              }}
                              onChangeActive={(event, newHover) => {
                                  setSkillLevelHover(newHover);
                              }}
                              max={5}
                              icon={<div className={`flex-1 w-7 h-10 rounded-sm`}></div>}
                              emptyIcon={<div className='flex-1 ml-0.5 w-7 h-10 rounded-sm bg-[#D9D9D9]'></div>}
                          />
                          <div className="flex justify-end md:justify-start items-center hover:cursor-pointer" onClick={handleSkillAdd}>
                              <img src='/Add_ring.svg' height={"40px"} width={"40px"} />
                          </div>
                      </div>
                  </div>
                </div>
              </form>
              {skillWithExpList?.length > 3 ? <div className='flex justify-start flex-wrap gap-6 mt-6'>
                {skillWithExpList?.slice(0,3).map((skillObject, i) => (
                  <div key={i} className={`bg-[#F1F2F5] py-3 px-5 relative cursor-pointer rounded-[1.4px] ${values[13].skill ? skillObject.skill === values[13].skill && 'border border-blue-1' : skillWithExpList.length - 1 === i && 'border border-blue-1'}`} onClick={() => editSkill(skillObject)}>
                    <div className='absolute top-1 left-1'>
                        <img src={`${skillObject.level <= 2 ? './redSkillTag.svg' : skillObject.level <= 4 ? 'yellowSkillTag.svg' : 'greenSkillTag.svg'}`} alt="" />
                    </div>
                    <div className=''>{skillObject.skill}</div>
                    <div className='mt-2'>{skillObject.year} years</div>
                    <div className='bg-[#6B6C7E] w-5 h-5 text-white-1 rounded-full flex justify-center items-center absolute top-0 -right-3 text-xs cursor-pointer' onClick={() => removeSkill(skillObject.skill)}><span>x</span> </div>
                  </div>
                ))}
                <FormControl
                  classes={{
                    root: classes.quantityRoot
                  }}
                  sx={{ m: 1, minWidth: 20 }}
                >
                  <Select
                    labelId="more skills"
                    displayEmpty
                    renderValue={(selected) => {
                        return <span className='text-[#0B5FFF] font-semibold text-xs'>+{skillWithExpList.length - 3} more</span>;
                    }}
                    classes={{
                      icon: classes.icon
                    }}
                  >
                    {skillWithExpList?.slice(3).map((skillObject) => (
                      <MenuItem value={skillObject}  onClick={() => editSkill(skillObject)}>
                        <div className='grid grid-cols-12 gap-2 w-full'>
                          <div className='col-span-2 flex justify-center items-center'><img src="./menuIcon.svg" alt="" /></div>
                          <div className='col-span-5'>{skillObject.skill}</div>
                          <div className='col-span-3'>{skillObject.year} years</div>
                          <div className='col-span-2 flex justify-center items-center'><img src="./deleteIcon.svg" alt="" onClick={() => removeSkill(skillObject.skill)} /></div>
                        </div>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div> :
              skillWithExpList?.length > 0 && <div className='flex justify-start flex-wrap gap-6 mt-6'>
                {skillWithExpList?.map((skillObject, i) => (
                  <div key={i} className={`bg-[#F1F2F5] py-3 px-5 relative cursor-pointer rounded-[1.4px] ${values[13].skill ? skillObject.skill === values[13].skill && 'border border-blue-1' : skillWithExpList.length - 1 === i && 'border border-blue-1'}`} onClick={() => editSkill(skillObject)}>
                    <div className='absolute top-1 left-1'>
                        <img src={`${skillObject.level <= 2 ? './redSkillTag.svg' : skillObject.level <= 4 ? 'yellowSkillTag.svg' : 'greenSkillTag.svg'}`} alt="" />
                    </div>
                    <div className=''>{skillObject.skill}</div>
                    <div className='mt-2'>{skillObject.year} years</div>
                    <div className='bg-[#6B6C7E] w-5 h-5 text-white-1 rounded-full flex justify-center items-center absolute top-0 -right-3 text-xs cursor-pointer' onClick={() => removeSkill(skillObject.skill)}><span>x</span> </div>
                  </div>
                ))}
              </div>
              }
            </div>
            <div className="mt-6">
              <div className="flex justify-between">
                <label htmlFor="username" className="block mb-2 md:text-base text-sm font-medium text-black-1">Full name</label>
                <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[0].error ? "visible" : "invisible"}`}>Fill this field to continue.</p>
              </div>
              {/* <input type="text" id="username" className="border-grey-7 font-medium border text-black-1 p-5 placeholder-grey-7 text-sm rounded-sm  block w-full" placeholder="Enter candidates full name" /> */}
              <TextField error={values[0].error} fullWidth id="username" placeholder='Enter candidates full name' value={values[0].fullName} onChange={handleChange(0, 'fullName')} variant="outlined" className='text-blue-1 p-5' />
            </div>
            <div className="mt-6">
              <div className="flex justify-between">
                <label htmlFor="gaperId" className="block mb-2 md:text-base text-sm font-medium text-black-1">Gaper Id</label>
                <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[1].error ? "visible" : "invisible"}`}>This id is already assigned!</p>
              </div>
              {/* <input type="text" id="gaperId" className="border-grey-7 font-medium border text-black-1 p-5 placeholder-grey-7 placeholder-font-normal text-sm rounded-sm  block w-full" placeholder="Enter Gaper ID" /> */}
              <TextField error={values[1].error} fullWidth id="gaperid" type="number" value={values[1].gaperId} placeholder='Enter Gaper ID' onChange={handleChange(1,'gaperId')} variant="outlined" inputProps={{min: 0}} onBlur={() => handleOnBlurEvent(1,'gaperId')} />
            </div>
            <div className="mt-6">
              <div className="flex justify-between">
                <label htmlFor="email" className="block mb-2 md:text-base text-sm font-medium text-black-1">Email address</label>
                <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[2].error ? "visible" : "invisible"}`}>The email address is incorrect!</p>
              </div>
              <TextField error={values[2].error} fullWidth type="email" id="email" value={values[2].email} onChange={handleChange(2, 'email')} placeholder='Enter candidates email address' variant="outlined" />
              {/* <input type="email" id="email" className="border-grey-7 font-medium border text-black-1 p-5 placeholder-grey-7 text-sm rounded-sm  block w-full" placeholder="Enter candidates email address" /> */}
            </div>
            <div className="mt-6">
              <div className="flex justify-between">
                <label htmlFor="contact" className="block mb-2 md:text-base text-sm font-medium text-black-1">Contract status</label>
                <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[3].error ? "visible" : "invisible"}`}>This status needs to be updated!</p>
              </div>
              <Select error={values[3].error} value={values[3].contractStatus} onChange={handleChange(3, 'contractStatus')}
                sx={{ width: 2 / 2 }}
                displayEmpty
                renderValue={
                  values[3].contractStatus !== "" ? undefined : () => <Placeholder>Enter contract status</Placeholder>
                }
              >
                <MenuItem value="Part Time">Part Time</MenuItem>
                <MenuItem value="Full Time">Full Time</MenuItem>
                <MenuItem value="Hourly">Hourly</MenuItem>
              </Select>
            </div>
            <div className="mt-6">
              <div className='grid grid-cols-12 gap-2'>
                <div className="col-span-6">
                  <div className="flex justify-between">
                    <label htmlFor="exp" className="block mb-2 md:text-base text-sm font-medium text-black-1">Experience</label>
                    <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[4].error ? "visible" : "invisible"}`}>Select years.</p>
                  </div>
                  <TextField error={values[4].error} fullWidth value={values[4].experienceInYears} onChange={handleChange(4, 'experienceInYears')} type="number" id="exp" placeholder='Your exp from 0-20 years' variant="outlined" className='font-medium text-black-1' inputProps={{ 'min': 0, 'max': 20 }} onBlur={() => handleOnBlurEvent(4,'experienceInYears')}  />
                </div>
                <div className="col-span-6">
                  <div className="flex justify-between">
                    <label htmlFor="contact" className="block mb-2 md:text-base text-sm font-medium text-black-1">Hourly rate</label>
                    <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[5].error ? "visible" : "invisible"}`}>Select hours.</p>
                  </div>
                  {/* <input type="Select" id="contact" className="border-grey-7 font-medium border text-black-1 p-5 placeholder-grey-7 text-sm rounded-sm  block w-full" placeholder="Hourly rate" /> */}
                  <TextField error={values[5].error} fullWidth value={values[5].hourlyRate} onChange={handleChange(5, 'hourlyRate')} type="number" id="contact" placeholder='Hourly rate' variant="outlined" className='font-medium text-black-1' onBlur={() => handleOnBlurEvent(5,'hourlyRate')} />
                </div>
              </div>
            </div>
            <div className="mt-6">
              <div className='md:grid md:grid-cols-12 gap-2 flex md:justify-center items-center justify-between'>
                <div className='col-span-10'>
                    <div className="flex justify-between">
                    <label htmlFor="industry" className="block mb-2 md:text-base text-sm font-medium text-black-1">Industry</label>
                    <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[6].error ? "visible":"invisible"}`}>Select an industry to continue.</p>
                    </div>
                    <Autocomplete
                        value={values[6].industry}
                        onChange={(event, newValue) => {
                            if (typeof newValue === 'string') {
                                var newstate = [...values];
                                newstate[6].industry = newValue;
                                newstate[6].error = false;
                                setValues(newstate);
                            } else if (newValue && newValue.inputValue) {
                            // Create a new value from the user input
                                var newstate = [...values];
                                newstate[6].industry = newValue?.inputValue;
                                newstate[6].error = false;
                                setValues(newstate);
                            } else {
                                var newstate = [...values];
                                newstate[6].industry = newValue?.value || '';
                                newstate[6].error = false;
                                setValues(newstate);
                            }
                        }}
                        filterOptions={(options, params) => {
                            const filtered = filter(options, params);
                    
                            const { inputValue } = params;
                            // Suggest the creation of a new value
                            const isExisting = options.some((option) => inputValue === option.value);
                            if (inputValue !== '' && !isExisting) {
                            filtered.push({
                                inputValue,
                                value: `Add "${inputValue}"`,
                            });
                            }
                    
                            return filtered;
                        }}
                        selectOnFocus
                        clearOnBlur
                        handleHomeEndKeys
                        id="industry"
                        options={displayIndustryOptions}
                        getOptionLabel={(option) => {
                            // Value selected with enter, right from the input
                            if (typeof option === 'string') {
                            return option;
                            }
                            // Add "xxx" option created dynamically
                            if (option.inputValue) {
                            return option.inputValue;
                            }
                            // Regular option
                            return option.value;
                        }}
                        renderOption={(props, option) => <li {...props}>{option.value}</li>}
                        sx={{ width: 2/2 }}
                        freeSolo
                        includeInputInList
                        renderInput={(params) => (
                            <TextField {...params}  error={values[6].error} placeholder='Enter related industry' />
                        )}
                        />
                </div>
                <div className="md:col-span-2 col-span-12 flex justify-end mt-6 hover:cursor-pointer" onClick={handleIndustryAdd}>
                    <img src='/Add_ring.svg' height={"40px"} width={"40px"}/>
                </div>
              </div>
              {selectedIndustries?.length > 3 ? <div className='flex justify-start flex-wrap gap-6 mt-6'>
                  {selectedIndustries?.slice(0,3).map((industryEl, i) => (
                      <div key={i} className={`bg-[#F1F2F5] py-3 px-5 relative cursor-pointer rounded-[2px] ${values[6].industry ? industryEl === values[6].industry && 'border border-blue-1' : selectedIndustries.length-1 === i && 'border border-blue-1'}`} onClick={() => editIndustry(industryEl)}>
                          <div className=''>{industryEl}</div>
                          <div className='bg-[#6B6C7E] w-5 h-5 text-white-1 rounded-full flex justify-center items-center absolute top-0 -right-3 text-xs cursor-pointer' onClick={() => removeIndustry(industryEl)}><span>x</span> </div>
                      </div>
                  ))}
                  <FormControl
                    classes={{
                      root: classes.quantityRoot
                    }}
                    sx={{ m: 1,}}
                  >
                    <Select
                      labelId="more industries"
                      displayEmpty
                      renderValue={(selected) => {
                          return <span className='text-[#0B5FFF] font-semibold text-xs'>+{selectedIndustries?.length - 3} more</span>;
                      }}
                      classes={{
                        icon: classes.icon
                      }}
                    >
                      {selectedIndustries?.slice(3).map((industry) => (
                        <MenuItem value={industry}  onClick={() => editIndustry(industry)}>
                          <div className='grid grid-cols-12 gap-2 w-full'>
                            <div className='col-span-2 px-3 flex justify-center items-center'><img src="./menuIcon.svg" alt="" /></div>
                            <div className='col-span-8'>{industry}</div>
                            <div className='col-span-2 px-3 flex justify-center items-center'><img src="./deleteIcon.svg" alt="" onClick={() => removeIndustry(industry)} /></div>
                          </div>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
              </div> :
                selectedIndustries?.length > 0 && <div className='flex justify-start flex-wrap gap-6 mt-6'>
                  {selectedIndustries.map((industryEl, i) => (
                      <div key={i} className={`bg-[#F1F2F5] py-3 px-5 relative cursor-pointer rounded-[2px] ${values[6].industry ? industryEl === values[6].industry && 'border border-blue-1' : selectedIndustries.length-1 === i && 'border border-blue-1'}`} onClick={() => editIndustry(industryEl)}>
                          <div className=''>{industryEl}</div>
                          <div className='bg-[#6B6C7E] w-5 h-5 text-white-1 rounded-full flex justify-center items-center absolute top-0 -right-3 text-xs cursor-pointer' onClick={() => removeIndustry(industryEl)}><span>x</span> </div>
                      </div>
                  ))}
              </div>}
            </div>
            <div className="mt-6">
              <div className='md:grid md:grid-cols-12 md:gap-2'>
                <div className="md:col-span-6">
                  <div className="flex justify-between">
                    <label htmlFor="contact" className="block mb-2 md:text-base text-sm font-medium text-black-1">Location</label>
                    <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[7].error ? "visible" : "invisible"}`}>Select location.</p>
                  </div>

                  <Select
                    error={values[7].error}
                    value={values[7].SelectedCountry}
                    onChange={handleChange(7, 'SelectedCountry')}
                    displayEmpty
                    renderValue={() => {
                      if (values[7].SelectedCountry !== "") {
                        return values[7].SelectedCountry
                      }
                      else {
                        return <Placeholder>Select country</Placeholder>
                      }
                    }}
                    sx={{ width: 2 / 2 }}
                  >
                    <ListSubheader>
                      <TextField
                        size="small"
                        // Autofocus on textfield
                        autoFocus
                        placeholder="Search Country"
                        fullWidth
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <SearchIcon />
                            </InputAdornment>
                          )
                        }}
                        onChange={(e) => setSearchTextForCountries(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key !== "Escape") {
                            // Prevents autoselecting item while typing (default Select behaviour)
                            e.stopPropagation();
                          }
                        }}
                      />
                    </ListSubheader>
                    {displayCountriesOptions.map((value, key) => (
                      <MenuItem value={value.country} key={key}>
                        <span className='flex'>
                          <img
                            loading="lazy"
                            width="36px"
                            height="20px"
                            src={`https://flagcdn.com/w20/${value.code}.png`}
                            srcSet={`https://flagcdn.com/w40/${value.code}.png`}
                            alt={`Flag of us`}
                            className="mr-2"
                          />
                          {value.country}
                        </span>
                      </MenuItem>
                    ))}
                  </Select>

                </div>
                <div className="md:col-span-6 md:mt-0 mt-6">
                  <div className="flex justify-between">
                    <label htmlFor="contact" className="block mb-2 md:text-base text-sm font-medium text-black-1">States</label>
                    <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[8].error ? "visible" : "invisible"}`}>Select states.</p>
                  </div>
                  <FormControl sx={{ minWidth: 2 / 2 }} disabled={displayStatesOptions?.length > 0 ? false : true}>
                    <Select
                      error={values[8].error}
                      placeholder="State"
                      value={values[8].SelectedState}
                      onChange={handleChange(8, 'SelectedState')}
                      onClose={() => setSearchTextForStates("")}
                      displayEmpty
                      renderValue={() => {
                        if (values[8].SelectedState !== "") {
                          return values[8].SelectedState
                        }
                        else {
                          return <Placeholder>Select states</Placeholder>
                        }
                      }}
                    >
                      <ListSubheader>
                        <TextField
                          size="small"
                          // Autofocus on textfield
                          autoFocus
                          placeholder="Search States"
                          fullWidth
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <SearchIcon />
                              </InputAdornment>
                            )
                          }}
                          onChange={(e) => setSearchTextForStates(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key !== "Escape") {
                              // Prevents autoselecting item while typing (default Select behaviour)
                              e.stopPropagation();
                            }
                          }}
                        />
                      </ListSubheader>
                      {displayStatesOptions?.map((e, key) => (
                        <MenuItem value={e} key={key}>
                          <span className='flex mr-2'>
                            <img src="/state.svg" className="mr-2 h-6 w-6" />
                            {e}
                          </span>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </div>
            </div>
            {/* avaliability */}
            <div className="mt-6">
              <div className="flex justify-between">
                <label htmlFor="industry" className="block mb-2 md:text-base text-sm font-medium text-black-1">Availability</label>
                <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[11].error ? "visible" : "invisible"}`}>Select availability.</p>
              </div>
              <Select
                error={values[11].error}
                value={values[11].availabilityValue}
                onChange={handleChange(11, 'availabilityValue')}
                displayEmpty
                renderValue={
                  values[11].availabilityValue !== "" ? undefined : () => <Placeholder>Select your availability</Placeholder>
                }
                sx={{ width: 2 / 2 }}
              >
                {
                  availability.map((ava, index) => (
                    <MenuItem value={ava.val} key={index}>{ava.val}</MenuItem>
                  ))
                }
              </Select>
            </div>
            {/* overlaping hours */}
            <div className="mt-6">
              <div className='md:grid md:grid-cols-12 md:gap-2'>
                <div className="md:col-span-6">
                  <div className="flex justify-between">
                    <label htmlFor="contact" className="block mb-2 md:text-base text-sm font-medium text-black-1">Time zone</label>
                    <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[9].error ? "visible" : "invisible"}`}>Select time zone.</p>
                  </div>
                  <Select
                    error={values[9].error}
                    value={values[9].timeZone}
                    onChange={handleChange(9, 'timeZone')}
                    onClose={() => setSearchText("")}
                    // This prevents rendering empty string in Select's value
                    // values[9].timeZone
                    // if search text would exclude currently selected option.
                    displayEmpty
                    renderValue={() => {
                      if (values[9].timeZone !== "") {
                        return values[9].timeZone
                      }
                      else {
                        return <Placeholder>Select Timezone</Placeholder>
                      }
                    }}
                    sx={{ width: 2 / 2 }}
                  >
                    <ListSubheader>
                      <TextField
                        size="small"
                        // Autofocus on textfield
                        autoFocus
                        placeholder="Search time zone"
                        fullWidth
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <SearchIcon />
                            </InputAdornment>
                          )
                        }}
                        onChange={(e) => setSearchText(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key !== "Escape") {
                            // Prevents autoselecting item while typing (default Select behaviour)
                            e.stopPropagation();
                          }
                        }}
                      />
                    </ListSubheader>
                    {displayTimezoneOptions?.map((timezone, key) => (
                      <MenuItem value={timezone} key={key}>
                        <span className='flex'>
                          <img src="/state.svg" className="mr-2 h-6 w-6" />
                          {timezone}
                        </span>
                      </MenuItem>
                    ))}
                  </Select>
                </div>
                <div className="md:col-span-6 md:mt-0 mt-6">
                  <div className="flex justify-between">
                    <label htmlFor="contact" className="block mb-2 md:text-base text-sm font-medium text-black-1">Overlapping hours</label>
                    <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[10].error ? "visible" : "invisible"}`}>Error</p>
                  </div>
                  <Select error={values[10].error} value={values[10].overlappingHours} onChange={handleChange(10, 'overlappingHours')}
                    displayEmpty
                    renderValue={
                      values[10].overlappingHours !== "" ? undefined : () => <Placeholder>Select hours</Placeholder>
                    }
                    sx={{ width: 2 / 2 }}
                  >
                    <MenuItem disabled>Select Hours</MenuItem>
                    {[...Array(8)].map((x, i) =>
                      <MenuItem key={i} value={i}>{i} Hour{i>1 && 's'}</MenuItem>
                    )}
                  </Select>
                </div>
              </div>
            </div>
            <div className="mt-6">
              <div className="flex justify-between">
                <label htmlFor="industry" className="block mb-2 md:text-base text-sm font-medium text-black-1">Language proficiency</label>
                <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[12].error ? "visible" : "invisible"}`}>Select language proficiency.</p>
              </div>
              <Select
                error={values[12].error}
                value={values[12].languageProficiency}
                onChange={handleChange(12, 'languageProficiency')}
                displayEmpty
                renderValue={
                  values[12].languageProficiency !== "" ? undefined : () => <Placeholder>English</Placeholder>
                }
                sx={{ width: 2 / 2 }}
              >
                <MenuItem value="1">Basic</MenuItem>
                <MenuItem value="2">Conversational</MenuItem>
                <MenuItem value="3">Fluent</MenuItem>
              </Select>
            </div>
            <div className="mt-6">
              <div className="flex justify-between">
                <label htmlFor="jobTitle" className="block mb-2 md:text-base text-sm font-medium text-black-1">Job title</label>
                <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[15].error ? "visible" : "invisible"}`}>Add a job title.</p>
              </div>
              {/* <input type="text" id="gaperId" className="border-grey-7 font-medium border text-black-1 p-5 placeholder-grey-7 placeholder-font-normal text-sm rounded-sm  block w-full" placeholder="Enter current job title" /> */}
              <TextField error={values[15].error} fullWidth value={values[15].currentJobTitle} onChange={handleChange(15, 'currentJobTitle')} type="text" id="jobTitle" placeholder='Enter current job title' variant="outlined" />
            </div>
              {isCompletedTab ? 
                <div className="mt-6">
                  <div className='md:grid md:grid-cols-12 gap-2 flex md:justify-center items-center justify-between'>
                    <div className='md:col-span-8'>
                      <div className="flex justify-between">
                        <label htmlFor="cvLink" className="block mb-2 md:text-base text-sm font-medium text-black-1">CV Link</label>
                        <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[16].error ? "visible" : "invisible"}`}>Add a CV less than 1 mb</p>
                      </div>
                      <TextField fullWidth value={values[16].cvFile?.name ? values[16].cvFile.name : cvLink} InputProps={{ readOnly: true }} type="text" id="cvLink" placeholder='Enter current job title' variant="outlined" />
                    </div>
                    <div className='md:col-span-4 col-span-12 flex justify-end mt-6 hover:cursor-pointer'>
                    <label for="file-upload" className="bg-[#D2D2D2] py-[3px] px-[11px] rounded-[1.4px] w-[86px] h-[31px] font-medium md:text-sm text-xs cursor-pointer overflow-hidden">
                        Change
                    </label>
                      <input type="file" id="file-upload" value={CV.name} onChange={handleFileUpload} accept="application/pdf" className='hidden' />
                    </div>
                  </div>
                </div>
                :
                
                  draftCv?
                  <>
                  <div className="mt-6">
                  <div className='md:grid md:grid-cols-12 gap-2 flex md:justify-center items-center justify-between'>
                    <div className='md:col-span-8'>
                      <div className="flex justify-between">
                        <label htmlFor="cvLink" className="block mb-2 md:text-base text-sm font-medium text-black-1">CV Link</label>
                        <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[16].error ? "visible" : "invisible"}`}>Add a CV less than 1 mb</p>
                      </div>
                      <TextField fullWidth value={values[16].cvFile?.name ? values[16].cvFile.name : draftCvValue} InputProps={{ readOnly: true }} type="text" id="cvLink" placeholder='Enter current job title' variant="outlined" />
                    </div>
                    <div className='md:col-span-4 col-span-12 flex justify-end mt-6 hover:cursor-pointer'>
                    <label for="file-upload" className="bg-[#D2D2D2] py-[3px] px-[11px] rounded-[1.4px] w-[86px] h-[31px] font-medium md:text-sm text-xs cursor-pointer overflow-hidden">
                        Change
                    </label>
                      <input type="file" id="file-upload" value={CV.name} onChange={handleFileUpload} accept="application/pdf" className='hidden' />
                    </div>
                  </div>
                </div>
                  </>:
                <div className="mt-6">
                <div className="flex justify-between">
                  <label htmlFor="file" className="block mb-2 md:text-base text-sm font-medium text-black-1">CV Link</label>
                  <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${values[16].error ? "visible" : "invisible"}`}>Add a CV less than 1 mb</p>
                </div>
                <input type="file" value={CV.name} onChange={handleFileUpload} accept="application/pdf" />
              </div>
                
              }
            <div className="mt-6">
              <div className='grid grid-cols-12 items-center'>
                <div className='col-span-4'>
                  <input type="button" className='bg-blue-1 w-full h-auto text-white-1 rounded-sm p-4 text-center cursor-pointer' value="Save" onClick={handleSubmit} />
                </div>
                <div className='col-span-8 ml-6'>
                  <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${error ? "visible" : "invisible"}`}>Some of the fields are missing!</p>
                </div>
              </div>
            </div>
          </div>
          <div className={`${showAvatars ? 'block' : 'hidden'} w-auto h-auto bg-white-1 rounded-md md:pl-20 md:pr-20 md:pt-8 md:pb-10 p-5`}>
            <div className='flex justify-between items-center'>
              <h1 className="md:text-2xl text-lg font-bold">Choose an Avatar</h1>

            </div>
            <div className='mt-6'>
              <Avatars avatarsList={avatarsList} avatarSelected={avatarSelected} handleChooseAvatar={handleChooseAvatar} />
            </div>
            <div className="mt-6">
              <div className='grid grid-cols-12 items-center'>
                <div className='col-span-4 flex justify-center'>
                  <input type="submit" className='bg-blue-1 w-11/12 h-[45px] text-white-1 rounded-sm text-center cursor-pointer' value="Save" />
                </div>
                <div className='col-span-8 ml-6'>
                  <p className={`md:text-sm text-xs text-red-1 md:font-medium font-normal italic ${error ? "visible" : "invisible"}`}>Please choose an Avatar!</p>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      </div>
    </>
  )
}

export default RightDrawer